export default __webpack_public_path__ + "0fd98a695931d7064587be0136a890ba.png";